import { useEffect, useState } from "react";
import { Clock, UserRound } from "lucide-react";
import { useI18n } from "@/i18n";

export const StatusFooter = ({ user, className = "" }) => {
  const { lang } = useI18n();
  const [now, setNow] = useState(new Date());
  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(id);
  }, []);
  const locale = lang === "es" ? "es-PA" : "en-US";
  const date = now.toLocaleDateString(locale, { weekday: "short", day: "2-digit", month: "short", year: "numeric" });
  const time = now.toLocaleTimeString(locale, { hour: "2-digit", minute: "2-digit", second: "2-digit" });
  return (
    <footer data-testid="status-footer" className={`flex items-center justify-between gap-3 flex-wrap text-[11px] text-muted-foreground border-t border-border pt-3 ${className}`}>
      <span className="inline-flex items-center gap-1.5 font-mono" data-testid="status-footer-datetime">
        <Clock className="w-3 h-3" /> <span className="capitalize">{date}</span> · {time}
      </span>
      {user ? (
        <span className="inline-flex items-center gap-1.5 truncate max-w-full" data-testid="status-footer-user">
          <UserRound className="w-3 h-3" /> <span className="font-medium text-foreground/80 truncate">{user.name || user.email}</span>
          <span className="truncate">· {user.email}</span>{user.tenant?.name && <span className="hidden sm:inline truncate">· {user.tenant.name}</span>}
        </span>
      ) : (
        <span className="font-medium">RapidPay v2</span>
      )}
    </footer>
  );
};
